// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__2mV2s","load6":"Loader_load6__13XjD","round":"Loader_round__3SqUz"};